import React, { Component } from 'react'

const scope = 'Header'
class Header extends Component {
  render() {
    const {
      config: { siteName },
    } = this.props
    return (
      <h1 className={scope}>
        <a href='/' title='Home'>
          {siteName}
        </a>
      </h1>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/common/header/header.jsx